const CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours
const CACHE_VERSION = "v14";
const VERSION_KEY = 'analysis_cache_version';

interface CachedAnalysis {
  data: any;
  timestamp: number;
}

// Auto-migration: Clear old versions of the cache if a version bump is detected
if (typeof window !== 'undefined') {
  const storedVersion = localStorage.getItem(VERSION_KEY);
  if (storedVersion !== CACHE_VERSION) {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('analysis_cache_')) {
        localStorage.removeItem(key);
      }
    });
    localStorage.setItem(VERSION_KEY, CACHE_VERSION);
  }
}

const getCacheKey = (ticker: string) => `analysis_cache_${CACHE_VERSION}_${ticker.trim().toUpperCase()}`;

export const getAnalysisFromCache = (ticker: string): any | null => {
  if (!ticker) return null;
  const key = getCacheKey(ticker);
  const cacheStr = localStorage.getItem(key);
  if (!cacheStr) return null;
  
  try {
    const cached: CachedAnalysis = JSON.parse(cacheStr);
    const now = Date.now();
    
    if (now - cached.timestamp < CACHE_TTL) {
      return cached.data;
    }
    
    // Expired
    localStorage.removeItem(key);
  } catch (e) {
    localStorage.removeItem(key);
  }
  return null;
};

export const saveAnalysisToCache = (ticker: string, data: any) => {
  if (!ticker || !data) return;
  const key = getCacheKey(ticker);
  const cached: CachedAnalysis = {
    data,
    timestamp: Date.now()
  };
  try {
    localStorage.setItem(key, JSON.stringify(cached));
  } catch (e) {
    console.warn('Cache storage failed, possibly out of space', e);
  }
};

export const clearAnalysisCache = (ticker?: string) => {
  if (ticker) {
    localStorage.removeItem(getCacheKey(ticker));
  } else {
    // Clear all analysis cache (all versions)
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('analysis_cache_')) {
        localStorage.removeItem(key);
      }
    });
  }
};
